import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { DeviationResourceType } from '../../../types/deviation';
import { BiData } from '@wix/da-bi/pkg/events';
const EditTier = ({ deviation, editTier })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItemButton, {
        label: t('common.edit'),
        onClick: editTier,
        biData: BiData({
            evid: 536,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId
        }),
        fillContainerWidth: true
    });
};
EditTier.displayName = 'EditTier';
export default EditTier;
